import httpInstances from '@/api/axiosInstance';
import type { SymbolKey } from '@/entities/symbol/types';
import { toQueryParams } from '@/utils/toQueryParams';

export type FeedSymbol = {
  alias: string;
  currency: string;
  title: string;
  units: string;
  periodAbs: string;
};

export const fetchSymbolData = async (code: SymbolKey, date: string): Promise<FeedSymbol> => {
  const params = toQueryParams({
    to: date.split('T')[0],
    size: 1,
    metadata: true,
    ...code
  });
  const { data } = await httpInstances.axiosDataInstance.get(`/index${params}`, {
    headers: {
      Accept: 'application/json'
    }
  });

  return {
    alias: data?.[0]?.metadata?.Alias,
    currency: data?.[0]?.metadata?.Currency,
    title: data?.[0]?.metadata?.Title,
    units: data?.[0]?.metadata?.Units,
    periodAbs: data?.[0]?.values?.PeriodAbs
  };
};
